import { Image } from '@chakra-ui/react';
import React from 'react';
import footerLogo from '@/assets/buffalobet/images/footer/logoFooter.svg';

export default function index() {
  return <Image src={footerLogo} minW="140px" minH="60px" />;
}
